

















































































































import { Component, Prop } from 'vue-property-decorator';
import { CSSStyleOptions } from '../common-types';
import { SwScrollView } from '../sw-scroll-view';
import { SwExtendedVue } from '../sw-extended-vue';
import { ScrollCallback, ResizeCallback, EventCallbackParam } from './types';
import { domService } from '../dom-service';

@Component({
  components: {
    SwScrollView,
  },
})
export default class SwDropdown extends SwExtendedVue {
  @Prop({ type: Boolean, default: true })
  withArrow: boolean;

  @Prop({ type: Number })
  maxWidth: number;

  @Prop({ type: Number })
  maxHeight: number;

  @Prop({ type: [Number] })
  width: number | undefined;

  @Prop({ type: Array, default: [] })
  customClasses: string[];

  /** because this component is used in popper-service to generate directive,
   * emitted events cannot be listened normally, so instead we have to use
   * callbacks to achieve the same goal.
   */
  @Prop({ type: Function })
  scrollCb: ScrollCallback;

  @Prop({ type: Function })
  resizeCb: ResizeCallback;

  cssPrefix: string = 'sw-dropdown';

  get innerStyle(): CSSStyleOptions {
    return {
      maxHeight: this.maxHeight !== Infinity ? `${this.maxHeight}px` : undefined,
      maxWidth: this.maxWidth !== Infinity ? `${this.maxWidth}px` : undefined,
      width: this.width !== undefined ? `${this.width}px` : undefined,
    };
  }

  private getEventCallbackParam(): EventCallbackParam | null {
    const scrollViewComp = this.$refs.scrollView as SwScrollView;
    if (!scrollViewComp) { return null; }
    return {
      rootEl: this.$el as HTMLElement,
      contEl: (this.$refs.scrollView as SwScrollView).$el as HTMLElement,
      clientWidth: scrollViewComp.clientWidth,
      clientHeight: scrollViewComp.clientHeight,
      scrollWidth: scrollViewComp.scrollWidth,
      scrollHeight: scrollViewComp.scrollHeight,
      scrollTop: scrollViewComp.scrollTop,
      scrollLeft: scrollViewComp.scrollLeft,
    };
  }

  private onScroll() {
    if (this.scrollCb && this.$refs.scrollView) {
      const param = this.getEventCallbackParam();
      if (param) { this.scrollCb(param); }
    }
  }

  private onResize() {
    if (this.resizeCb && this.$refs.scrollView) {
      const scrollViewComp = this.$refs.scrollView as SwScrollView;
      scrollViewComp.updateSizes()
      .then(() => {
        const param = this.getEventCallbackParam();
        if (param) { this.resizeCb(param); }
      });
    }
  }

  private onInnerResize() {
    if (this.$refs.scrollView) {
      const scrollViewComp = this.$refs.scrollView as SwScrollView;
      scrollViewComp.updateSizes()
      .then(() => {
        if (scrollViewComp.clientHeight >= scrollViewComp.scrollHeight) {
          (this.$el as HTMLElement).style.height = '';
          this.$emit('request-update');
        }
      });
    }
  }

  private mounted() {
    this.$nextTick(() => {
      if (this.$refs.scrollView) {
        domService.resizeObserver.on((this.$refs.scrollView as SwScrollView).$el as HTMLElement, this.onResize);
      }
      if (this.$refs.inner) {
        domService.resizeObserver.on(this.$refs.inner as HTMLElement, this.onInnerResize);
      }
    });
  }

  private beforeDestroy() {
    if (this.$refs.scrollView) {
      domService.resizeObserver.off((this.$refs.scrollView as SwScrollView).$el as HTMLElement, this.onResize);
    }
    if (this.$refs.inner) {
      domService.resizeObserver.off(this.$refs.inner as HTMLElement, this.onInnerResize);
    }
  }
}
